;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:propstrata-app":true});}catch(e){}}();import type { QueryClient } from "@tanstack/react-query";
import { queryKeysForReconnect } from "@/lib/client-invalidation/query-keys-for-event";

export async function invalidateOnReconnect(input: {
	organizationId?: string;
	queryClient: QueryClient;
	userId?: string;
	workspaceId?: string;
}): Promise<void> {
	const queryKeys = queryKeysForReconnect({
		organizationId: input.organizationId,
		userId: input.userId,
		workspaceId: input.workspaceId,
	});

	await Promise.all(
		queryKeys.map((queryKey) =>
			input.queryClient.invalidateQueries({ queryKey }),
		),
	);
}
